const allLenders = [
  {
    slug: 'kheslc',
    rateSlug: 'kheslc',
    name: 'Advantage <br/>Education Loans',
    minAmount: 7500,
    maxAmount: 500000,
    minCreditScore: 650,
  },
  {
    slug: 'brazos',
    rateSlug: 'brazos',
    name: 'Brazos',
    minAmount: 10000,
    maxAmount: 250000,
    minCreditScore: 650,
  },
  {
    slug: 'cas',
    rateSlug: 'cas',
    name: 'College Ave',
    minAmount: 5000,
    maxAmount: 300000,
    minCreditScore: 650,
  },
  {
    slug: 'purefy',
    rateSlug: 'cordiagrad',
    name: 'PenFed',
    minAmount: 7500,
    maxAmount: Number.MAX_VALUE,
    minCreditScore: 650,
  },
  {
    slug: 'mefa',
    rateSlug: 'mefa',
    name: 'MEFA',
    minAmount: 10000,
    maxAmount: Number.MAX_VALUE,
    minCreditScore: 650,
  },
  {
    slug: 'invested',
    rateSlug: 'invested',
    name: 'INvestEd',
    minAmount: 5000,
    maxAmount: 250000,
    minCreditScore: 600,
  },
  {
    slug: 'citizens',
    rateSlug: 'citizens-bank',
    name: 'Citizens',
    minAmount: 10000,
    maxAmount: 500000,
    minCreditScore: 640,
  },
  {
    slug: 'sofi',
    rateSlug: 'sofi',
    name: 'SoFi',
    minAmount: 5000,
    maxAmount: Number.MAX_VALUE,
    minCreditScore: 640,
  },
  {
    slug: 'isl',
    rateSlug: 'isl',
    name: 'Iowa Student Loan',
    minAmount: 5000,
    maxAmount: 300000,
    minCreditScore: 670,
  },
  {
    slug: 'commonbond',
    rateSlug: 'commonbond',
    name: 'Commonbond',
    minAmount: 5000,
    maxAmount: 300000,
    minCreditScore: 670,
  },
]

export { allLenders }
